<template>
  <el-row class="box_img">
    <el-col :span="24">
      <img class="img_left" src="../../static/mac_left.png" alt="">
      <img class="img_right" src="../../static/info_right.png" alt="">
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'Footer',
    props: [''],
    data() {
      return {
      }
    },
    components: {},

    computed: {},

    mounted() {},

    methods: {}
  }

</script>
<style lang='' scoped>
  .box_img{
    margin-top:100px;
  }
  .img_left{
    width:700px;
  }
  .img_right{
    width:400px;
    margin-left:220px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .box_img{
      margin-top:30px;
    }
    .img_left{
      width:500px;
    }
    .img_right{
      width:300px;
      margin-left:120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Footer.vue